export function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <div className="footer">
            <div className="container">
                <div className="row">
                    <div className="col col-12">
                    &copy; Copyright {currentYear} Zayne Browning. All rights reserved.
                    </div>
                </div>
            </div>
        </div>
    );
}